import React from 'react';
import LocationAndTransactionType from '../components/add-beneficiary/location-and-transaction-type';
import BeneficiaryPersonalInformation from '../components/add-beneficiary/personal-information';
import BeneficiaryBankAccountDetails from '../components/add-beneficiary/bank-account-details';
import usePayoutStore from '../../../../store/payout';

interface AddBeneficiaryProps {
  addBeneficiary: () => void;
  caller?: string;
  step?: number;
  goNext?: () => void;
  prev?: () => void;
  loading?: boolean;
}

const AddBeneficiary: React.FC<AddBeneficiaryProps> = ({
  addBeneficiary,
  caller = '',
  step = 1,
  goNext = () => {},
  prev = () => {},
  loading = false,
}) => {
  const { beneficiaryFormState } = usePayoutStore();

  return (
    <div>
      {caller === 'payout' ? (
        <div>
          {beneficiaryFormState !== 'selected_existing' && (
            <LocationAndTransactionType goNext={goNext} caller={caller} />
          )}
          <BeneficiaryPersonalInformation
            goNext={goNext}
            prev={prev}
            caller={caller}
          />
          <BeneficiaryBankAccountDetails
            addBeneficiary={() => {}}
            prev={prev}
            loading={loading}
            caller={caller}
          />
        </div>
      ) : (
        <div>
          {step === 1 && (
            <LocationAndTransactionType goNext={goNext} caller={caller} />
          )}
          {step === 2 && (
            <BeneficiaryPersonalInformation
              goNext={goNext}
              prev={prev}
              caller={caller}
            />
          )}
          {step === 3 && (
            <BeneficiaryBankAccountDetails
              addBeneficiary={addBeneficiary}
              prev={prev}
              loading={loading}
              caller={caller}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default AddBeneficiary;
